module.exports = __webpack_public_path__ + "static/media/show-colors.8cbe0f57.svg";